export default __webpack_public_path__ + "static/media/retur-penjualan.466ff110.png";